export default function TestimonialShowcase() {
  return (
    <section className="py-24 bg-[#FFF8F0] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/55803f344a30961e4d9eb65b9f56b3c7.jpg"
          alt="Background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-[1200px] mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="text-[#E67E22] text-xs font-semibold tracking-[0.2em] uppercase mb-6">
            CLIENT TESTIMONIALS
          </div>
        </div>

        <div className="relative">
          <div className="text-[#E67E22] text-9xl font-serif absolute -top-8 left-0 opacity-20">"</div>
          <blockquote className="text-4xl lg:text-6xl font-bold text-[#2C2C2C] text-center leading-tight mb-12 relative z-10 px-8">
            ScapeWorx transformed our backyard into something we only dreamed about. The attention to detail is remarkable.
          </blockquote>
        </div>

        <div className="flex items-center justify-center gap-6">
          <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-white shadow-lg">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20portrait%20of%20happy%20homeowner%20couple%20smiling%20in%20their%20beautiful%20backyard%20with%20simple%20clean%20background&width=200&height=200&seq=test002&orientation=squarish"
              alt="Client"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="text-left">
            <div className="flex items-center gap-2 mb-1">
              <div className="font-bold text-xl text-gray-900">Sarah & James Mitchell</div>
              <div className="bg-green-500 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1 whitespace-nowrap">
                <i className="ri-checkbox-circle-fill"></i>
                Verified
              </div>
            </div>
            <div className="text-gray-600 mb-2">Glen Mills, PA</div>
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#E67E22]"></i>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}